import {
  DATA_TYPE_ARTICLE_COUNTS,
  DATA_TYPE_PAGE_VIEWS,
  DATA_TYPE_QUALITY_SCORE,
  DATA_TYPE_REVISION_COUNT,
} from 'models'
import { getCountry } from './countries'

type Texts = {
  [index: string]: string
}

export const countries: Texts = {
  ad: getCountry('ad'),
  ae: getCountry('ae'),
  af: getCountry('af'),
  ag: getCountry('ag'),
  ai: getCountry('ai'),
  al: getCountry('al'),
  am: getCountry('am'),
  ao: getCountry('ao'),
  aq: getCountry('aq'),
  ar: getCountry('ar'),
  as: getCountry('as'),
  at: getCountry('at'),
  au: getCountry('au'),
  aw: getCountry('aw'),
  ax: getCountry('ax'),
  az: getCountry('az'),
  ba: getCountry('ba'),
  bb: getCountry('bb'),
  bd: getCountry('bd'),
  be: getCountry('be'),
  bf: getCountry('bf'),
  bg: getCountry('bg'),
  bh: getCountry('bh'),
  bi: getCountry('bi'),
  bj: getCountry('bj'),
  bl: getCountry('bl'),
  bm: getCountry('bm'),
  bn: getCountry('bn'),
  bo: getCountry('bo'),
  br: getCountry('br'),
  bs: getCountry('bs'),
  bt: getCountry('bt'),
  bw: getCountry('bw'),
  by: getCountry('by'),
  bz: getCountry('bz'),
  ca: getCountry('ca'),
  cc: getCountry('cc'),
  cd: getCountry('cd'),
  cf: getCountry('cf'),
  cg: getCountry('cg'),
  ch: getCountry('ch'),
  ci: getCountry('ci'),
  ck: getCountry('ck'),
  cl: getCountry('cl'),
  cm: getCountry('cm'),
  cn: getCountry('cn'),
  co: getCountry('co'),
  cr: getCountry('cr'),
  cu: getCountry('cu'),
  cv: getCountry('cv'),
  cw: getCountry('cw'),
  cx: getCountry('cx'),
  cy: getCountry('cy'),
  cz: getCountry('cz'),
  de: getCountry('de'),
  dj: getCountry('dj'),
  dk: getCountry('dk'),
  dm: getCountry('dm'),
  do: getCountry('do'),
  dz: getCountry('dz'),
  ec: getCountry('ec'),
  ee: getCountry('ee'),
  eg: getCountry('eg'),
  eh: getCountry('eh'),
  er: getCountry('er'),
  es: getCountry('es'),
  et: getCountry('et'),
  fi: getCountry('fi'),
  fj: getCountry('fj'),
  fk: getCountry('fk'),
  fm: getCountry('fm'),
  fo: getCountry('fo'),
  fr: getCountry('fr'),
  ga: getCountry('ga'),
  gb: getCountry('gb'),
  gd: getCountry('gd'),
  ge: getCountry('ge'),
  gf: getCountry('gf'),
  gg: getCountry('gg'),
  gh: getCountry('gh'),
  gi: getCountry('gi'),
  gl: getCountry('gl'),
  gm: getCountry('gm'),
  gn: getCountry('gn'),
  gp: getCountry('gp'),
  gq: getCountry('gq'),
  gr: getCountry('gr'),
  gs: getCountry('gs'),
  gt: getCountry('gt'),
  gu: getCountry('gu'),
  gw: getCountry('gw'),
  gy: getCountry('gy'),
  hk: getCountry('hk'),
  hn: getCountry('hn'),
  hr: getCountry('hr'),
  ht: getCountry('ht'),
  hu: getCountry('hu'),
  id: getCountry('id'),
  ie: getCountry('ie'),
  il: getCountry('il'),
  im: getCountry('im'),
  in: getCountry('in'),
  iq: getCountry('iq'),
  ir: getCountry('ir'),
  is: getCountry('is'),
  it: getCountry('it'),
  je: getCountry('je'),
  jm: getCountry('jm'),
  jo: getCountry('jo'),
  jp: getCountry('jp'),
  ke: getCountry('ke'),
  kg: getCountry('kg'),
  kh: getCountry('kh'),
  ki: getCountry('ki'),
  km: getCountry('km'),
  kn: getCountry('kn'),
  kp: getCountry('kp'),
  kr: getCountry('kr'),
  kw: getCountry('kw'),
  ky: getCountry('ky'),
  kz: getCountry('kz'),
  la: getCountry('la'),
  lb: getCountry('lb'),
  lc: getCountry('lc'),
  li: getCountry('li'),
  lk: getCountry('lk'),
  lr: getCountry('lr'),
  ls: getCountry('ls'),
  lt: getCountry('lt'),
  lu: getCountry('lu'),
  lv: getCountry('lv'),
  ly: getCountry('ly'),
  ma: getCountry('ma'),
  mc: getCountry('mc'),
  md: getCountry('md'),
  me: getCountry('me'),
  mf: getCountry('mf'),
  mg: getCountry('mg'),
  mh: getCountry('mh'),
  mk: getCountry('mk'),
  ml: getCountry('ml'),
  mm: getCountry('mm'),
  mn: getCountry('mn'),
  mo: getCountry('mo'),
  mp: getCountry('mp'),
  mq: getCountry('mq'),
  mr: getCountry('mr'),
  ms: getCountry('ms'),
  mt: getCountry('mt'),
  mu: getCountry('mu'),
  mv: getCountry('mv'),
  mw: getCountry('mw'),
  mx: getCountry('mx'),
  my: getCountry('my'),
  mz: getCountry('mz'),
  na: getCountry('na'),
  nc: getCountry('nc'),
  ne: getCountry('ne'),
  nf: getCountry('nf'),
  ng: getCountry('ng'),
  ni: getCountry('ni'),
  nl: getCountry('nl'),
  no: getCountry('no'),
  np: getCountry('np'),
  nr: getCountry('nr'),
  nu: getCountry('nu'),
  nz: getCountry('nz'),
  om: getCountry('om'),
  pa: getCountry('pa'),
  pe: getCountry('pe'),
  pf: getCountry('pf'),
  pg: getCountry('pg'),
  ph: getCountry('ph'),
  pk: getCountry('pk'),
  pl: getCountry('pl'),
  pm: getCountry('pm'),
  pn: getCountry('pn'),
  pr: getCountry('pr'),
  ps: getCountry('ps'),
  pt: getCountry('pt'),
  pw: getCountry('pw'),
  py: getCountry('py'),
  qa: getCountry('qa'),
  re: getCountry('re'),
  ro: getCountry('ro'),
  rs: getCountry('rs'),
  ru: getCountry('ru'),
  rw: getCountry('rw'),
  sa: getCountry('sa'),
  sb: getCountry('sb'),
  sc: getCountry('sc'),
  sd: getCountry('sd'),
  se: getCountry('se'),
  sg: getCountry('sg'),
  sh: getCountry('sh'),
  si: getCountry('si'),
  sj: getCountry('sj'),
  sk: getCountry('sk'),
  sl: getCountry('sl'),
  sm: getCountry('sm'),
  sn: getCountry('sn'),
  so: getCountry('so'),
  sr: getCountry('sr'),
  ss: getCountry('ss'),
  st: getCountry('st'),
  sv: getCountry('sv'),
  sx: getCountry('sx'),
  sy: getCountry('sy'),
  sz: getCountry('sz'),
  tc: getCountry('tc'),
  td: getCountry('td'),
  tf: getCountry('tf'),
  tg: getCountry('tg'),
  th: getCountry('th'),
  tj: getCountry('tj'),
  tk: getCountry('tk'),
  tl: getCountry('tl'),
  tm: getCountry('tm'),
  tn: getCountry('tn'),
  to: getCountry('to'),
  tr: getCountry('tr'),
  tt: getCountry('tt'),
  tv: getCountry('tv'),
  tw: getCountry('tw'),
  tz: getCountry('tz'),
  ua: getCountry('ua'),
  ug: getCountry('ug'),
  us: getCountry('us'),
  uy: getCountry('uy'),
  uz: getCountry('uz'),
  va: getCountry('va'),
  vc: getCountry('vc'),
  ve: getCountry('ve'),
  vg: getCountry('vg'),
  vi: getCountry('vi'),
  vn: getCountry('vn'),
  vu: getCountry('vu'),
  wf: getCountry('wf'),
  ws: getCountry('ws'),
  xk: getCountry('xk'),
  ye: getCountry('ye'),
  yt: getCountry('yt'),
  za: getCountry('za'),
  zm: getCountry('zm'),
  zw: getCountry('zw'),
}

export const texts: Texts = {
  category: 'Category',
  colorBy: 'Color by',
  contents: 'Contents',
  contributors: 'Contributors',
  dataFrom: 'Data from',
  dimension: 'Dimension',
  english: 'English',
  groupByColor: 'Group by color',
  knowledgeGap: 'Knowledge Gap',
  language: 'Language',
  normalization: 'Normalization',
  project: 'Project',
  readers: 'Readers',
  richTable: 'Rich Table',
  timeframe: 'Timeframe',
  timespan: 'Timespan',
  value: 'value',
  visualization: 'Visualization',
  wikipedia: 'Wikipedia',
  wikiquote: 'Wikiquote',
  wikisource: 'Wikisource',
  [DATA_TYPE_ARTICLE_COUNTS]: 'Article counts',
  [DATA_TYPE_PAGE_VIEWS]: 'Page views',
  [DATA_TYPE_QUALITY_SCORE]: 'Quality score',
  [DATA_TYPE_REVISION_COUNT]: 'Revision count',
  ...countries,
}
